const minimize = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M11.125 5.935 13.19 8H8V2.81l2.065 2.065L14.47.47l1.06 1.06zm-5.19 5.19L1.53 15.53.47 14.47l4.405-4.405L2.81 8H8v5.19z"/></svg>',
};

export { minimize as default };
